import LTRes from "../../LTGame/Res/LTRes";
import ResDefine from "../common/ResDefine";
export default class MaterialManager {
    constructor() {
        this._actorMat = {};
        this._enemyMat = {};
    }
    static get instance() {
        if (!this._instance) {
            this._instance = new MaterialManager();
            window["MaterialManager"] = this._instance;
        }
        return this._instance;
    }
    PreLoad(urls) {
        urls.push(ResDefine.FixMat(ResDefine.whiteMat));
    }
    Clear() {
        this._actorMat = {};
        this._enemyMat = {};
    }
    GetWhiteMaterial(id, src, normal) {
        let rst = this._actorMat[id];
        if (!rst) {
            this._actorMat[id] = src;
        }
        if (normal) {
            return rst;
        }
        if (!this.whiteMat) {
            this.whiteMat = LTRes.Get(ResDefine.FixMat(ResDefine.whiteMat));
        }
        return this.whiteMat;
    }
    GetEnemyWhite(id, src, normal) {
        let rst = this._enemyMat[id];
        if (!rst) {
            this._enemyMat[id] = src;
        }
        if (normal) {
            return rst;
        }
        if (!this.whiteMat) {
            this.whiteMat = LTRes.Get(ResDefine.FixMat(ResDefine.whiteMat));
        }
        return this.whiteMat;
    }
}
